export const StructuredData = () => {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "PorteroYa",
    "url": "https://porteroya.com",
    "description": "Connect with qualified goalkeepers in your area. Book with confidence and play with the best.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://porteroya.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "PorteroYa",
      "logo": {
        "@type": "ImageObject",
        "url": "https://porteroya.com/meta/logo.svg"
      }
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61556743824804",
      "https://x.com/PorteroYa",
      "https://www.instagram.com/porteroyaoficial/",
      "https://www.linkedin.com/company/porteroya"
    ],
    "inLanguage": ["en", "es", "ca"]
  };

  const sportsActivitySchema = {
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "name": "PorteroYa",
    "description": "Platform connecting soccer teams with goalkeepers in Spain",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "ES"
    },
    "audience": {
      "@type": "Audience",
      "audienceType": "Soccer teams and goalkeepers"
    },
    "provider": {
      "@type": "Organization",
      "name": "PorteroYa",
      "url": "https://porteroya.com"
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(sportsActivitySchema)}
      </script>
    </>
  );
};